import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: inline-block;
`;

const getIcon = (color, size) => {
  return {
    clock: (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size + 2} ${size + 2}`}
        strokeWidth="1.5"
        stroke={color}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <circle cx="12" cy="12" r="9" />
        <polyline points="12 7 12 12 15 15" />
      </svg>
    ),
    send: (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size + 2} ${size + 2}`}
        strokeWidth="1.5"
        stroke={color}
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <line x1="10" y1="14" x2="21" y2="3" />
        <path d="M21 3l-6.5 18a0.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a0.55 .55 0 0 1 0 -1l18 -6.5" />
      </svg>
    ),
  };
};

export default function Icon(props) {
  return (
    <Wrapper {...props}>{getIcon(props.color, props.size)[props.type]}</Wrapper>
  );
}
